






































interface SelectOption {
  label: string;
  value: string;
  selected: boolean;
}

import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CustomSelectBox extends Vue {
  @Prop({ required: true }) private name!: string;
  @Prop({ default: () => [] }) private data!: SelectOption[];
  @Prop({ required: true }) private onSelect!: Function;
  @Prop({ required: true }) private onDeselect!: Function;
  @Prop() private onSelectAll!: Function;
  @Prop() private onUnselectAll!: Function;
  @Prop() private onInputChanged!: Function;
  @Prop({ default: () => false }) private hasFooter!: boolean;
  @Prop({ default: () => "Search" }) private placeholder!: string;
  @Prop({ default: () => false }) private isError?: boolean;
  @Prop({ default: () => false }) private isInputDisabled?: boolean;
  @Prop({ default: () => true }) private isSearcheable?: boolean;

  unselected: SelectOption[] = this.data;

  @Watch("data", {
    immediate: true,
    deep: true,
  })
  dataChanged(newData: SelectOption[], oldData: SelectOption[]) {
    this.data = newData;
    this.unselected = this.data.filter((option) => !option.selected);
  }
}
